module.exports = __webpack_public_path__ + "static/media/logo_fluidit.73fc1c29.svg";